<shared-modal [modalTitle]="selectTitle" [modalIcon]="selectIcon" [showFooter]="false">
  @if (items.length >= 5) {
    <div class="nav-item-menu-item select-list-item" modalHeader>
      <shared-search-input (search)="applyFilter($event)" />
    </div>
  }

  <ng-container modalBody>
    @if (items) {
      <ul class="scroll-list">
        @for (item of items | appFilter: itemFilter : 'label'; track item.id; let idx = $index) {
          <li (click)="selectItem(item)" class="select-item" [ngClass]="{ selected: isItemSelected(item.id) }" [tabindex]="idx" role="option" [attr.aria-selected]="isItemSelected(item.id)">
            {{ item.label }}
          </li>
        }
      </ul>
    }
    @if (!items) {
      <div>
        <p>There are no items</p>
      </div>
    }
  </ng-container>
</shared-modal>
